import * as AlertActionCreator from "./AlertsActionCreator";


export function defaultAlertListState() {
    return {
      loading: false,
      response: null,
      error: null,
      
    };
  }

  export const AlertListReducer = (state, action) => {
    if (
      !state ||
      action.type === AlertActionCreator.ALERTS_ACTION.RESET_ALERTS_LIST_STATE
    ) {
      return { ...state, ...defaultAlertListState() };
    } 
  
    if (action.type === AlertActionCreator.ALERTS_ACTION.REQUEST_ALERTS_LIST) {
      return { ...state, loading: true};
    }
  
    if (action.type === AlertActionCreator.ALERTS_ACTION.RESPONSE_ALERTS_LIST) {
      return { ...state, response: action.data, loading: false };
    }
  
    if (action.type === AlertActionCreator.ALERTS_ACTION.ERROR_ALERTS_LIST) {
      return { ...state, error: action.data, loading: false, response: null };
    }
  
    return state; 
  };

  export function defaultSideNavState () {
    return {
      isOpen: false,
      // isMobileOpen: false,
    }
  }
  
  export const SideNavReducer = (state, action) => {
    if (
      !state ||
      action.type === AlertActionCreator.ALERTS_ACTION.RESET_SIDE_NAV_STATE
    ) {
      return { ...state, ...defaultSideNavState() };
    }
    if (action.type === AlertActionCreator.ALERTS_ACTION.TOOGLE_SIDE_NAV_STATE) {
      return { ...state, isOpen: !state.isOpen };
    }
    return state;
  };